import { useEffect } from 'react';
import { useNavigation } from '@react-navigation/native';

import { useFeatureFlag } from '@order/LaunchDarkly';

/**
 * This component is used to wrap screens that are part of the OrderProduct flow.
 * It prevent the screen from being rendered if the feature flag is disabled.
 */
export const OrderProductGuard = ({ children }: OrderProductGuardProps) => {
  const isProductDeepLinkingEnabled = useFeatureFlag(
    'product-deep-linking-enabled',
  );

  const navigation = useNavigation();

  useEffect(() => {
    if (isProductDeepLinkingEnabled) return;

    navigation.navigate('MainTabs', {
      screen: 'HomeTab',
      params: {
        screen: 'Home',
      },
    });
  }, [isProductDeepLinkingEnabled, navigation]);

  return isProductDeepLinkingEnabled ? children : null;
};

type OrderProductGuardProps = {
  readonly children: JSX.Element;
};
